import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AppConfig } from 'src/app/app.config';

@Injectable()
export class DemoService {
    constructor(private http: HttpClient, public oidcSecurityService: OidcSecurityService) { }

    baseUrl = `${AppConfig.apiHost}`;

    getIdentity(): Observable<any> {
        const endpoint = `${this.baseUrl}/api/demo/identity`;
        return this.http.get<any>(endpoint).pipe(
            catchError(error => {
                // this.oidcSecurityService.handleError(error); // Handles 401/403 errors, if present
                return throwError(error);
            })
        );
    }
}
